/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import { PositionLinePermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import { checkRol } from '../../../../../security';
import { notificador, proveedorNotificador } from '../../../../../security/constantsRols';
import WeeklyLinesContainer from '../WeeklyLinesContainer/WeeklyLinesContainer';

import '../WeeklyView.scss';

const PositionRowContainer = (props) => {
  const {
    changeInLine,
    indexPosition,
    newFetch,
    position,
    positionLinesPermissions,
    selectedDate,
    setChangeInLine,
    setNewFetch,
    startDate,
    workReportId,
    typeOfUbication,
    disabledEditStateCancelOrFinish,
    forceWindow,
    isOyM
  } = props;

  const [lines, setLines] = useState([]);

  useEffect(() => {
    const adapter = position?.lineas?.map((line) => ({
      ...line,
      lineName: `${line.numeroLinea} - ${line.descripcionLineaSap}`,
      numeroPosicion: position.numeroPosicion,
      descripcionPosicionSap: position.descripcionPosicionSap,
      idPartetrabajo: line.idPartetrabajo,
      idParteLinea: line.idParteLinea
    }));

    setLines(adapter);
  }, [position]);

  const isNotifyingProviderRole = checkRol(proveedorNotificador);
  const isProviderOrNotifier = checkRol(proveedorNotificador) || checkRol(notificador);
  const isLineBlockedBySap = position?.lineas?.find((l) => l?.bloqueadoEnSap === true);

  return (
    <>
      <Col className="mt-5" sm={12}>
        <div className="label_row_position">Posición</div>
        <div className="postion_row_name">
          <span className={`${isLineBlockedBySap && isNotifyingProviderRole ? 'text-danger' : ''}`}>
            {position?.positionName?.toUpperCase()}
          </span>
        </div>
      </Col>
      {lines.map((line, index) => (
        <WeeklyLinesContainer
          changeInLine={changeInLine}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          forceWindow={forceWindow}
          indexLine={index}
          indexPosition={indexPosition}
          isOyM={isOyM}
          isProviderOrNotifier={isProviderOrNotifier}
          // eslint-disable-next-line react/no-array-index-key
          key={`${line.numeroLinea}-${index}`}
          line={line}
          newFetch={newFetch}
          positionLinesPermissions={positionLinesPermissions}
          selectedDate={selectedDate}
          setChangeInLine={setChangeInLine}
          setLines={setLines}
          setNewFetch={setNewFetch}
          showSeparator={lines.length > 1}
          startDate={startDate}
          typeOfUbication={typeOfUbication}
          workReportId={workReportId}
        />
      ))}
    </>
  );
};

PositionRowContainer.propTypes = {
  workReportId: PropTypes.number.isRequired,
  indexPosition: PropTypes.number.isRequired,
  position: PropTypes.shape({
    descripcionPosicionSap: PropTypes.string,
    descripcionPosicionYClic: PropTypes.string,
    idPartetrabajo: PropTypes.number,
    idPosicion: PropTypes.number,
    numeroPosicion: PropTypes.number,
    lineas: PropTypes.arrayOf(
      PropTypes.shape({
        descripcionLineaSap: PropTypes.string,
        descripcionLineaYClic: PropTypes.string,
        numeroLinea: PropTypes.number,
        partesDiarios: PropTypes.arrayOf(PropTypes.shape({})),
        unidadMedida: PropTypes.string
      })
    ),
    positionName: PropTypes.string,
    idParteLinea: PropTypes.number
  }).isRequired,
  changeInLine: PropTypes.bool.isRequired,
  newFetch: PropTypes.bool.isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  selectedDate: PropTypes.string.isRequired,
  setChangeInLine: PropTypes.func.isRequired,
  setNewFetch: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  typeOfUbication: PropTypes.string.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  forceWindow: PropTypes.bool,
  isOyM: PropTypes.bool
};

PositionRowContainer.defaultProps = {
  forceWindow: null,
  isOyM: false
};

export default PositionRowContainer;
